import { getTimeZone, toUtc, dateMath } from '@grafana/data';
import { SceneObjectUrlSyncConfig } from '../services/SceneObjectUrlSyncConfig.js';
import { SceneObjectBase } from './SceneObjectBase.js';

var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
class SceneTimeRange extends SceneObjectBase {
  constructor(state = {}) {
    var _a, _b, _c;
    const from = (_a = state.from) != null ? _a : "now-6h";
    const to = (_b = state.to) != null ? _b : "now";
    const timeZone = (_c = state.timeZone) != null ? _c : getTimeZone();
    const value = evaluateTimeRange(from, to, timeZone);
    super(__spreadValues({ from, to, timeZone, value }, state));
    this._urlSync = new SceneObjectUrlSyncConfig(this, { keys: ["from", "to"] });
    this.onTimeRangeChange = (timeRange) => {
      const update = {};
      if (typeof timeRange.raw.from === "string") {
        update.from = timeRange.raw.from;
      } else {
        update.from = timeRange.raw.from.toISOString();
      }
      if (typeof timeRange.raw.to === "string") {
        update.to = timeRange.raw.to;
      } else {
        update.to = timeRange.raw.to.toISOString();
      }
      update.value = evaluateTimeRange(update.from, update.to, this.state.timeZone);
      this.setState(update);
    };
    this.onRefresh = () => {
      this.setState({ value: evaluateTimeRange(this.state.from, this.state.to, this.state.timeZone) });
    };
  }
  getUrlState() {
    return { from: this.state.from, to: this.state.to };
  }
  updateFromUrl(values) {
    var _a, _b;
    if (!values.to && !values.from) {
      return;
    }
    const update = {};
    const from = parseUrlParam(values.from);
    if (from) {
      update.from = from;
    }
    const to = parseUrlParam(values.to);
    if (to) {
      update.to = to;
    }
    update.value = evaluateTimeRange((_a = update.from) != null ? _a : this.state.from, (_b = update.to) != null ? _b : this.state.to, this.state.timeZone);
    this.setState(update);
  }
}
function parseUrlParam(value) {
  if (typeof value !== "string") {
    return null;
  }
  if (value.indexOf("now") !== -1) {
    return value;
  }
  if (value.length === 8) {
    const utcValue = toUtc(value, "YYYYMMDD");
    if (utcValue.isValid()) {
      return utcValue.toISOString();
    }
  } else if (value.length === 15) {
    const utcValue = toUtc(value, "YYYYMMDDTHHmmss");
    if (utcValue.isValid()) {
      return utcValue.toISOString();
    }
  } else if (value.length === 24) {
    const utcValue = toUtc(value);
    return utcValue.toISOString();
  }
  const epoch = parseInt(value, 10);
  if (!isNaN(epoch)) {
    return toUtc(epoch).toISOString();
  }
  return null;
}
function evaluateTimeRange(from, to, timeZone, fiscalYearStartMonth) {
  return {
    from: dateMath.parse(from, false, timeZone, fiscalYearStartMonth),
    to: dateMath.parse(to, true, timeZone, fiscalYearStartMonth),
    raw: {
      from,
      to
    }
  };
}

export { SceneTimeRange };
//# sourceMappingURL=SceneTimeRange.js.map
